import React from "react";
import MainTasksTable from "./Serving/PriorityTableComponents/MainTasksTable";

import "../style/home.css";

export default function Home() {

    return (
        <>
            <div className="home-2nd-container">
                <div>
                    <MainTasksTable/>
                </div>
            </div>
        </>
    );
}

